import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@nexus/ui"
import { useTranslation } from "react-i18next"
import { truncateSetName } from "../../../lib/format-opportunity.js"

export interface RegenSetDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  setName: string
  onConfirm: () => void
}

export function RegenSetDialog({ open, onOpenChange, setName, onConfirm }: RegenSetDialogProps) {
  const { t } = useTranslation()

  const displayName = truncateSetName(setName)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t("opportunities.regenSetDialogTitle", "Regenerate opportunities?")}</DialogTitle>
          <DialogDescription>
            {t("opportunities.regenSetDialogDescription", {
              name: displayName,
              defaultValue: `Regenerating "{{name}}" will replace all existing opportunities with a new AI generation run. This action cannot be undone.`,
            })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)}>
            {t("common.cancel")}
          </Button>
          <Button type="button" onClick={onConfirm}>
            {t("opportunities.regenSetConfirm", "Regenerate")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
